import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, CircularProgress } from '@mui/material';
import { Delete } from '@mui/icons-material';

interface RemoveShipmentConfirmDialogProps {
  open: boolean;
  trailerNumber?: string | null;
  shipmentNumber?: string | null;
  isRemoving: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const RemoveShipmentConfirmDialog: React.FC<RemoveShipmentConfirmDialogProps> = ({
  open,
  trailerNumber,
  shipmentNumber,
  isRemoving,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ color: 'error.main' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Delete />
          Remove Shipment Relationship
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Are you sure you want to remove the shipment relationship from trailer <strong>{trailerNumber}</strong>?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Current shipment: <strong>{shipmentNumber}</strong>
        </Typography>
        <Typography variant="body2" color="error.main" sx={{ mt: 1, fontWeight: 'medium' }}>
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose}
          disabled={isRemoving}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={isRemoving}
          startIcon={isRemoving ? <CircularProgress size={16} /> : <Delete />}
        >
          {isRemoving ? 'Removing...' : 'Remove Relationship'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveShipmentConfirmDialog;

